import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { BsThreeDots } from "react-icons/bs";
import apiInterceptor from "services/apiInterceptor";
import AssignedUsersTable from "./AssignedUsersTable";
import { subscriptionApiEndpoint } from "constant/apiConstants";
const ViewRole = () => {
  const { roleGuid } = useParams<{ roleGuid: string }>();
  const [roleDetails, setRoleDetails] = React.useState<any>(null);
  useEffect(() => {
    apiInterceptor
      .get(`${subscriptionApiEndpoint?.ENDPOINT_USER_ROLE}/${roleGuid}`) 
      .then((response) => {
        console.log(response.data);
        setRoleDetails(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching role details:", error);
      });
  }, [roleGuid]);

  return (
    <div>
      <div className="card p-6 d-flex flex-column  justify-content-between">
        <div className="d-flex justify-content-between flex-wrap gap-10">
          <div>
            <div className="d-flex align-items-baseline gap-4">
              <h1 className="fs-32 mt-2">{roleDetails?.displayName}</h1>
            </div>
          </div>
          <div>
            <div>
              <div>
                <button className="btn d-none btn-secondary p-2 py-1 mt-1">
                  <BsThreeDots />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-4">
          <div className="card m-0 p-0 mb-5">
            <div className="  m-0 border-bottom d-flex justify-content-between align-items-center  p-5">
              <div className="fs-18px fw-medium">Privileges</div>
            </div>
            <div className=" p-5">
              <div className="m-0">
                <ul className="feature-list text-gray-700 p-5 m-0">
                  {roleDetails?.description.map((desc: string, index: number) =>
                    index < 5 ? (
                      <li className="mb-1" key={desc}>
                        {desc}
                      </li>
                    ) : null
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-8">
          <div className="card m-0 p-10 mb-5">
            <AssignedUsersTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRole;
